module.exports = __webpack_public_path__ + "static/4-c726d8d8d5641d6cc3da2e9063921b42.png";